<template>
  <Layout>
    <!-- Start Service Area -->
    <section class="rn-service-area rn-section-gap">
      <div class="container">
        <div class="row row--30">
          <div class="col-lg-12">
            <SectionTitle
              class="mb--50"
              text-align="center"
              subtitle="Where People and Technology Intersect"
              title="Serving the Needs of Our Clients"
              data-aos="fade-up"
              data-aos-delay="60"
            />
          </div>
        </div>
        <div class="row row--15 service-wrapper">
          <div
            v-for="(service, index) in serviceCards"
            :key="index"
            class="col-6"
          >
            <ServiceCard
              :service="service"
              :service-style="`service__style--1 bg-color-blackest radius mt--25`"
              :icon-size="62"
              text-align="left"
            />
          </div>
        </div>
      </div>
    </section>
    <!-- End Service Area -->

  </Layout>
</template>

<script>
    import Layout from '../components/common/Layout'
    import SectionTitle from '../components/elements/sectionTitle/SectionTitle'
    import ServiceCard from '../components/elements/service/ServiceCard'

    export default {
        name: 'Company',
        components: {Layout, SectionTitle, ServiceCard},
        data() {
            return {
                serviceCards: [
                    {
                        icon: 'user-plus',
                        id: 'growth-leadership',
                        title: 'Growth Leadership',
                        description: '<p>We offer fractional engineering leadership, management coaching, and executive advisory sessions to help your teams stay aligned, make strong decisions, and navigate future growth confidently.</p>',
                        readMore: {
                          readMoreButton: true,
                        },
                    },
                    {
                        icon: 'map',
                        id: 'growth-navigation',
                        title: 'Growth Navigation',
                        description: '<p>We work alongside your teams to improve delivery, strengthen structure, and build the capabilities your organization needs to scale—without adding new layers of leadership or long-term dependency.</p>',
                        readMore: {
                          readMoreButton: true,
                        },
                    },
                    {
                        icon: 'crosshair',
                        id: 'growth-inflection-analysis',
                        title: 'Growth Inflection Analysis',
                        description: '<p>A focused, two-week engagement that gives your software engineering organization clarity on where you are today, where you want to go, and what\'s standing in the way.</p>',
                        readMore: {
                          readMoreButton: true,
                        },
                    },
                    {
                        icon: 'cpu',
                        id: 'ai-stabilization-and-growth-framework',
                        title: 'AI Stabilization & Growth Framework',
                        description: '<p>The AI Stabilization &amp; Growth Framework helps your organization move from a state of reactive chaos to one of proactive advantage. We don\'t just help you stay in the race; we help you build an organization that is calm and systematically designed to win it, no matter how the technology changes.</p>',
                        readMore: {
                          readMoreButton: true,
                        },
                    },
                ],
             }
        }
    }
</script>
